var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-notifications"},[_c('r-title',[_vm._v(_vm._s(_vm.title))]),_c(`public-notifications-${_vm.mode}`,{tag:"component",attrs:{"source_id":_vm.source_id,"selected":_vm.selected},on:{"mode":_vm.changeMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }